import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Loading placeholder for {@link McapSegmentPage}, shown as the route's
 * `pendingComponent` while the loader warms the logical-segment query. Mirrors
 * the page shape: header + action, the metadata grid, and the copy-plan table.
 */
export function McapSegmentPageSkeleton() {
  return (
    <section className="space-y-4">
      <header className="flex items-start justify-between gap-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-6 w-56" />
          <Skeleton className="h-4 w-64" />
        </div>
        <Skeleton className="h-8 w-32" />
      </header>

      <div className="grid gap-3 rounded-lg border p-4 sm:grid-cols-3">
        {Array.from({ length: 8 }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder list
          <div key={i} className="space-y-1.5">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-full" />
          </div>
        ))}
      </div>

      <div className="space-y-3 rounded-lg border p-4">
        <Skeleton className="h-5 w-48" />
        <Skeleton className="h-24 w-full" />
      </div>
    </section>
  );
}
